import { useMatch, useNavigate } from "react-router"
import ProcessTable from "./ProcessTable"
import styles from './index.module.less'
import classNames from "classnames"
import { LeftOutlined, LoadingOutlined } from "@ant-design/icons"
import { Button, Select, Spin } from "antd"
import { useRequest } from "ahooks"
import { useEffect, useMemo } from "react"
import { getMaterialBalance, getMaterialBalanceForCase } from "@/services/project/material-balance.service"
import { getProjectCases } from "@/services/project/cases.service"
import { exportMaterialBalanceFile, getMaterialBalanceData } from "./excel.service"
import { getPropertySet } from "@/services/project/project"
import { getActiveUnitSet } from "@/services/unitSet/unitSet.service"



export const MaterialBalance = () => {
  const match = useMatch('/main/projects/:projectId/mb/:id')
  const id = match?.params.id || ''
  const projectId = match?.params.projectId || ''
  const navigate = useNavigate()
  const {data: balance} = useRequest(() => getMaterialBalance(id))
  const {data: cases = []} = useRequest(() => getProjectCases({pId: projectId}))

  const {data: mbDetail, run, loading} = useRequest((caseId) => getMaterialBalanceForCase({id, caseId}), {manual: true})
  const {data: propertySet, run: loadPropertySet} = useRequest((id) => getPropertySet(projectId, id), {manual: true})
  const {data: unitSet} = useRequest(() => getActiveUnitSet({projectId: projectId}))

  const streams = mbDetail?.streams || [];
  const firstStream = streams[0]

  useEffect(() => {
    if (!firstStream) return;
    loadPropertySet(firstStream.ppsId)
  }, [firstStream?.ppsId])

  const caseOptions = useMemo(() => {
    if (!(cases.length > 0 && (balance?.cases || []).length > 0)) {
      return []
    }
    return cases.filter((item) => {
      return balance!.cases.includes(item.id)
    }).map(item => {
      return {
        value: item.id,
        label: `${item.name}[No.:${item.number}]`
      }
    })
  }, [cases, balance])

  const mbData = useMemo(() => {
    if (!(mbDetail && propertySet && unitSet)) return;
    return getMaterialBalanceData(mbDetail, propertySet, unitSet)
  }, [mbDetail, propertySet, unitSet])

  const onSelect = (caseId: number) => {
    run(caseId)
  }

  const exportDoc = async () => {
    if (!mbData) return;
    await exportMaterialBalanceFile(mbData, mbDetail!.name)
  }

  const showTable = !loading && mbDetail

  return <div className={styles.pageContainer}>
    <div className={classNames(styles.header, 'flex-center')}>
      <div className={styles.backBtn}>
        <LeftOutlined className={styles.iconAction} onClick={() => {
          navigate(`/main/projects/${projectId}/workspace`)
        }} />
      </div>
      <div>{balance?.name || '-'}</div>
    </div>
    <div className={styles.body}>
      <div className={styles.left}>
        <div className={classNames(styles.tableContainer, loading && 'flex-center')}>
          {loading && <Spin indicator={<LoadingOutlined spin />} size="large" />}
          {showTable && mbData && <ProcessTable mbData={mbData} />}
        </div>
        
      </div>
      <div className={classNames('p-1', styles.right)}>
        <div className="mt-1 flex-start">Case: <Select options={caseOptions} style={{flex: 1, marginLeft: 20}} onSelect={onSelect}/></div>
        <div className="mt-1 flex-end">
          <Button onClick={exportDoc}>Export</Button>
        </div>
      </div>
    </div>
  </div>
}